export default {"src":"/_next/static/media/property-news-icon.34b4b1ab.svg","height":81,"width":96,"blurWidth":0,"blurHeight":0};